import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isOpen", "children", "onClose", "title"];
import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { ModalStyled } from '@nike/nike-design-system-components';
import PropTypes from 'prop-types';
var Modal = function Modal(t0) {
  var $ = _c(14);
  var children;
  var isOpen;
  var onClose;
  var rest;
  var title;
  if ($[0] !== t0) {
    var _t = t0;
    isOpen = _t.isOpen;
    children = _t.children;
    onClose = _t.onClose;
    title = _t.title;
    rest = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = children;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = rest;
    $[5] = title;
  } else {
    children = $[1];
    isOpen = $[2];
    onClose = $[3];
    rest = $[4];
    title = $[5];
  }
  var t1;
  if ($[6] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "label.close",
      primaryValue: "Close",
      description: "Modal close button accessibility string"
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  var modalCloseAriaLabel = useI18nString(t1);
  var t2;
  if ($[7] !== children || $[8] !== isOpen || $[9] !== modalCloseAriaLabel || $[10] !== onClose || $[11] !== rest || $[12] !== title) {
    t2 = /*#__PURE__*/React.createElement(ModalStyled, _extends({
      isOpen: isOpen,
      closeModal: onClose,
      title: title,
      modalCloseAriaLabel: modalCloseAriaLabel
    }, rest), children);
    $[7] = children;
    $[8] = isOpen;
    $[9] = modalCloseAriaLabel;
    $[10] = onClose;
    $[11] = rest;
    $[12] = title;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
Modal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.element]),
  onClose: PropTypes.func,
  title: PropTypes.string
};
export default Modal;